module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="player-popup-overlay">\n	<div class="player-popup-inner">\n		<a class="icon-close js-close">\n			<i class="ion-android-close"></i>\n		</a>\n		<div class="player-popup-data">\n			<div class="header squad-'+
((__t=( squad_id ))==null?'':_.escape(__t))+
'">\n				<div class="squad-silhouette" style="background-image: url(/assets/images/squad-logos/'+
((__t=( squad_id ))==null?'':_.escape(__t))+
'.svg);"></div>\n				<div class="player-info">\n					<a class="icon icon-favourite js-favourite '+
((__t=( is_favourite ? 'is-favourite' : '' ))==null?'':_.escape(__t))+
'">\n						<i class="ion-ios-star-outline"></i>\n						<i class="ion-android-star"></i>\n					</a>\n					<div class="player-name">\n						<p>'+
((__t=( first_name ))==null?'':_.escape(__t))+
'</p>\n						<p>'+
((__t=( last_name ))==null?'':_.escape(__t))+
'</p>\n					</div>\n					<div class="player-stats">\n						<p>\n							'+
((__t=( _.currencyFormat(cost) ))==null?'':_.escape(__t))+
'\n						</p>\n\n						<p class="player-squad-name">\n							'+
((__t=( squad_name ))==null?'':_.escape(__t))+
' | <span>'+
((__t=( position_names.join(' , ') ))==null?'':_.escape(__t))+
'</span>\n						</p>\n						<p>\n							<b>'+
((__t=( squad.short_name ))==null?'':_.escape(__t))+
'</b> '+
((__t=( opponents.symbol ))==null?'':_.escape(__t))+
' '+
((__t=( opponent.short_name ))==null?'':_.escape(__t))+
'\n						</p>\n					</div>\n\n					<a href="/player-profile/'+
((__t=( id ))==null?'':_.escape(__t))+
'" class="external-btn" target="_blank">FULL PLAYER PROFILE</a>\n				</div>\n				<div class="player-avatar">\n					<figure>\n						<picture>\n							<source srcset="'+
((__t=( _.getPlayerAvatarUrl({ id: id, size: 450, format:'webp' }) ))==null?'':_.escape(__t))+
'" type="image/webp" />\n							<img src="'+
((__t=( _.getPlayerAvatarUrl({ id: id, size: 450 }) ))==null?'':_.escape(__t))+
'" alt="">\n						</picture>\n					</figure>\n				</div>\n			</div>\n			<header class="player-popup-header player-cell-btns hidden">\n				';
 if(is_authorized){ 
__p+='\n					<a class="icon icon-favourite js-favourite '+
((__t=( is_favourite ? 'is-favourite' : '' ))==null?'':_.escape(__t))+
'">\n						<i class="ion-ios-star-outline"></i>\n						<i class="ion-android-star"></i>\n					</a>\n				';
 } 
__p+='\n				<a class="icon-close js-close">\n					<i class="ion-android-close"></i>\n				</a>\n			</header>\n			<section class="player-popup-body hidden">\n				';
 if(is_from_field){ 
__p+='\n					<div class="field-position-name field-position-'+
((__t=( field_position ))==null?'':_.escape(__t))+
'">\n						<div class="bench-position-label">\n							<span>'+
((__t=( field_position ))==null?'':_.escape(__t))+
'</span>\n							';
 if(bench_rank){ 
__p+='\n								<i class="bench-index">'+
((__t=( bench_rank ))==null?'':_.escape(__t))+
'</i>\n							';
 } 
__p+='\n						</div>\n					</div>\n				';
 } 
__p+='\n				<figure>\n					<picture>\n						<source	srcset="'+
((__t=( _.getPlayerAvatarUrl({ id: id, size: 100, format:'webp' }) ))==null?'':_.escape(__t))+
'" type="image/webp" />\n						<img src="'+
((__t=( _.getPlayerAvatarUrl({ id: id, size: 100 }) ))==null?'':_.escape(__t))+
'" alt="">\n					</picture>\n				</figure>\n				<div class="player-info">\n					<div class="player-name">\n					<span>\n						<i class="icon player-status '+
((__t=( status ))==null?'':_.escape(__t))+
'"></i>\n					</span>\n						<span>'+
((__t=( first_name ))==null?'':_.escape(__t))+
' '+
((__t=( last_name ))==null?'':_.escape(__t))+
'</span>\n					</div>\n					<div class="player-stats">\n					<span class="player-squad-name">\n						'+
((__t=( squad_name ))==null?'':_.escape(__t))+
'\n					</span>\n						<span class="player-positions">\n						<span> | </span>\n						<span>'+
((__t=( position_names.join(' , ') ))==null?'':_.escape(__t))+
'</span>\n						<span> | </span>\n						<span>'+
((__t=( _.currencyFormat(cost, '') ))==null?'':_.escape(__t))+
'</span>\n					</span>\n						<br>\n						<span class="'+
((__t=( cost_season_diff > 0 ? 'positive' : '' || cost_season_diff < 0 ? 'negative' : '' ))==null?'':_.escape(__t))+
'">\n						'+
((__t=( _.currencyFormat(cost_season_diff, '$', true) ))==null?'':_.escape(__t))+
'\n					</span>\n						<span> </span>\n						(\n						<span class="'+
((__t=( cost_round_diff > 0 ? 'positive' : '' || cost_round_diff < 0 ? 'negative' : '' ))==null?'':_.escape(__t))+
'">\n						'+
((__t=( _.currencyFormat(cost_round_diff, '$', true) ))==null?'':_.escape(__t))+
'\n					</span>\n						)\n					</div>\n				</div>\n				<a href="/player-profile/'+
((__t=( id ))==null?'':_.escape(__t))+
'" class="secondary-btn" target="_blank">FULL PROFILE</a>\n			</section>\n			<section class="player-popup-stats">\n				<div class="column">\n					<p>Rnd '+
((__t=( last_round_id ))==null?'':_.escape(__t))+
' Points</p>\n					<b>'+
((__t=( stats.points_last_round_original || '-' ))==null?'':_.escape(__t))+
'</b>\n				</div>\n				<div class="column">\n					<p>Total Points</p>\n					<b>'+
((__t=( stats.total_points ))==null?'':_.escape(__t))+
'</b>\n				</div>\n				<div class="column">\n					<p>Average Points</p>\n					<b>'+
((__t=( Math.round10(stats.avg_points || 0, -2) ))==null?'':_.escape(__t))+
'</b>\n				</div>\n				<div class="column">\n					<p>Owned %</p>\n					<b>'+
((__t=( (stats.owned_by || 0).toFixed(1) ))==null?'':_.escape(__t))+
'%</b>\n				</div>\n				<div class="column">\n					<p>Rnd '+
((__t=( actual_round_id ))==null?'':_.escape(__t))+
' Opp</p>\n					<b>'+
((__t=( opponents.symbol ))==null?'':_.escape(__t))+
' '+
((__t=( opponent.short_name ))==null?'':_.escape(__t))+
'</b>\n				</div>\n				<div class="column coach-stats">\n					<p>Rnd '+
((__t=( actual_round_id ))==null?'':_.escape(__t))+
' Projection</p>\n					';
 if(has_assistant_coach){ 
__p+='\n						<b>'+
((__t=( stats.proj_score ))==null?'':_.escape(__t))+
'</b>\n					';
 } else { 
__p+='\n						<img class="coach-locked js-coach-locked" src="/assets/images/icon-coach-locked.png" alt="">\n					';
 } 
__p+='\n				</div>\n				<div class="column coach-stats">\n					<p>Rnd '+
((__t=( actual_round_id ))==null?'':_.escape(__t))+
' BE</p>\n					';
 if(has_assistant_coach){ 
__p+='\n						<b>'+
((__t=( stats.break_even ))==null?'':_.escape(__t))+
'</b>\n					';
 } else { 
__p+='\n						<img class="coach-locked js-coach-locked" src="/assets/images/icon-coach-locked.png" alt="">\n					';
 } 
__p+='\n				</div>\n				<div class="column coach-stats">\n					<p>Proj Price Change</p>\n					';
 if(has_assistant_coach){ 
__p+='\n						<b>\n							'+
((__t=( _.currencyFormat(stats.proj_prices[next_round_id] - cost, '$', true) ))==null?'':_.escape(__t))+
'\n						</b>\n					';
 } else { 
__p+='\n						<img class="coach-locked js-coach-locked" src="/assets/images/icon-coach-locked.png" alt="">\n					';
 } 
__p+='\n				</div>\n			</section>\n			';
 if(has_assistant_coach){ 
__p+='\n			<section class="price-predictor">\n				<div class="price-predictor-desc">\n					<div>\n						<p>PRICE PREDICTOR</p>\n\n						<span>\n							Predict an average score for the next\n							<br>\n							3 rounds to view predicted price changes.\n						</span>\n					</div>\n					<div>\n						<input type="text" placeholder="0" name="avg_score_3" class="'+
((__t=( has_assistant_coach ? 'js-price-predictor' : 'js-coach-locked' ))==null?'':_.escape(__t))+
'" />\n					</div>\n				</div>\n				<div class="price-predictor-prices">\n					';
 _.each(next_3_rounds, function(round_id) { 
__p+='\n						<div>\n							<span class="round">ROUND '+
((__t=( round_id ))==null?'':_.escape(__t))+
'</span>\n							<p class="js-price-round-'+
((__t=( round_id ))==null?'':_.escape(__t))+
'">\n								';
 if(has_assistant_coach){ 
__p+='\n									?\n								';
 } else { 
__p+='\n									<img class="coach-locked js-coach-locked" src="/assets/images/icon-coach-locked.png" alt="">\n								';
 } 
__p+='\n							</p>\n							<span class="js-price-change-round-'+
((__t=( round_id ))==null?'':_.escape(__t))+
'"></span>\n						</div>\n					';
 }) 
__p+='\n				</div>\n			</section>\n			';
 } 
__p+='\n		</div>\n	</div>\n</div>';
}
return __p;
};
